// extracted by mini-css-extract-plugin
export default {"tableData":"selfassessment_tableData__ikP4x","avatar":"selfassessment_avatar__WlPnE"};